// src/components/PageTracker.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMatomo } from 'react-matomo';

const PageTracker = () => {
  const location = useLocation();
  const { trackPageView } = useMatomo();

  useEffect(() => {
    trackPageView(location.pathname);
    
    //console.log(`[Matomo] Tracked page: ${location.pathname}`);
  }, [location, trackPageView]);

  return null;
};

export default PageTracker;